<template>
  <v-layout row justify-center>
    <v-dialog v-model="params.show" max-width="600px">
      <v-form id="newTicketForm">
        <v-card>
          <v-card-title>
            <span class="headline">Novo Chamado</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  <v-text-field
                    label="Assunto*"
                    v-model="params.subject"
                    required
                  >
                  </v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-textarea
                    solo
                    label="Descrição*"
                    v-model="params.description"
                    persistent-hint
                    required
                  >
                  </v-textarea>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    label="Código da venda"
                    v-model="params.sale_code"
                    hint="Deixe em branco caso não tenha nenhum código"
                  >
                  </v-text-field>
                </v-flex>

                <v-flex xs12 text-xs-center>
                  <v-btn
                    class="white--text"
                    v-bind:color="color"
                    @click="onSelectFiles"
                  >
                    Anexar Arquivos
                  </v-btn>
                  <div v-if="fileParams.files.length > 0">
                    {{ quantityFilesSelected() }}
                    <span>
                      <v-btn
                        fab
                        outline
                        small
                        color="info"
                        @click="removeAllFiles"
                      >
                        <v-icon>close</v-icon>
                      </v-btn>
                    </span>
                  </div>
                </v-flex>

                <input
                  type="file"
                  multiple
                  style="display: none"
                  ref="fileInput"
                  accept="image/png,image/jpg,image/jpeg,.pdf,.txt,.doc,.docx,.xls,.xlsx,.csv"
                  @change="onFilesSelected"
                />
              </v-layout>
            </v-container>
            <small>*campos requeridos</small>
            <br />
            <small>
              Apenas arquivos com até 7mb e extensões: PDF, TXT, DOC, XLS, CSV,
              PNG, JPEG.
            </small>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn v-bind:color="color" flat @click="params.show = false"
              >Fechar</v-btn
            >
            <v-btn
              class="white--text"
              v-bind:color="color"
              @click="submitNewTicket"
              >Enviar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </v-layout>
</template>
<script>
import { mapGetters } from "vuex";
import { EventBus } from "@/services/event-bus";

export default {
  name: "NewTicket",
  created() {
    EventBus.$on("show-new-ticket-form", () => {
      this.params.show = true;
    });
    EventBus.$on("hide-new-ticket-form", () => {
      this.params.show = false;
    });
  },
  computed: {
    ...mapGetters({
      newTicketId: "tickets/newTicketId",
      color: "account/color",
    }),
  },
  watch: {
    // eslint-disable-next-line
    newTicketId: function () {
      this.submitFiles();
      this.goToTicketPage();
    },
  },
  data: () => ({
    params: {
      show: false,
      subject: "",
      description: "",
      sale_code: "",
      files: []
    },
    fileParams: {
      files: [],
    },
  }),
  methods: {
    submitNewTicket() {
      this.$store.dispatch("tickets/postNewTicket",{...this.params, files: this.fileParams.files});
      this.params.show = false;
    },
    submitFiles() {
      if (this.fileParams.files.length > 0) {
        const store = this.$store;
        const ticketId = this.newTicketId;

        this.fileParams.files.forEach((file) => {
          // TODO: Implementar upload via backend API
          // Por enquanto, apenas simula o upload
          const fakeUrl = `https://api.example.com/uploads/${Date.now()}-${file.name}`;
          
          store.dispatch("tickets/postNewComment", {
            message: fakeUrl,
            ticketId: ticketId,
            isFile: true,
          });
        });
      }
    },
    goToTicketPage() {
      this.$router.push({
        name: "ticket",
        params: { id: this.$store.state.tickets.newTicketId },
      });
    },
    onSelectFiles() {
      this.$refs.fileInput.click();
    },
    onFilesSelected(event) {
      for (const file in this.$refs.fileInput.files) {
        if (!this.$refs.fileInput.files.hasOwnProperty(file)) continue;

        const fileObj = this.$refs.fileInput.files[file];
        this.fileParams.files.push(fileObj);
      }

      var totalSize = 0;

      this.fileParams.files.forEach((element) => {
        totalSize += element.size;
      });
      if (totalSize > 7000000) {
        this.fileParams.files = [];
        alert("O tamanho dos arquivos excedeu o tamanho máximo permitido!");
      }
    },
    quantityFilesSelected() {
      return `${this.fileParams.files.length} arquivo(s) selecionado(s)`;
    },
    removeAllFiles() {
      this.fileParams.files = [];
    },
  },
};
</script>
